import { Labeled, ReferenceField, TextField } from "react-admin";
import { Grid } from "@mui/material";
import BackButtonToolbar from "features/BackButtonToolbar";
import { studentRequests } from "api/studentApi";

const CyclicExamFormTopToolbar = ({ cyclicStreamId }) => {
  return (
    <Grid
      container
      sx={{ mx: 2, mt: 4, justifyContent: "space-between", verticalAlign: "middle" }}
    >
      <Grid
        item
        sx={{ pt: 2 }}
      >
        <Labeled label="Поток">
          <ReferenceField
            source="id"
            reference={studentRequests.getCyclicStreamsSelect()}
            record={{ id: cyclicStreamId }}
          >
            <TextField
              source="name"
              sx={{ fontSize: "16px" }}
            />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        sx={{ pr: 2 }}
      >
        <BackButtonToolbar />
      </Grid>
    </Grid>
  );
};
export default CyclicExamFormTopToolbar;
